import style, { createGlobalStyle } from 'styled-components';

interface IButtonContainer {
  marginBottom?: boolean;
}

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Rawline';
    src: url('/fonts/Rawline/rawline-600.ttf') format('truetype');
  }
`;

export const ButtonContainer = style.div<IButtonContainer>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #f8f8f8;
  border-radius: 100px;
  width: 180px;
  cursor: pointer;
  min-height: 40px;
  margin-bottom: ${(props) => (props.marginBottom ? '16px' : '0px')};

  &:hover {
    background-color: #d6ddec;
  }
`;

export const ButtonText = style.span`
  color: #1351b4;
  font-family: 'Rawline', serif;
`;

export const ButtonImage = style.img`
  width: auto;
  height: 20px;
`;
